"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ImportProductStatusTrans = exports.ImportProductStatus = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.values.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _nhanh = require("@/api/nhanh");
var _provider = require("@/api/provider");
var _importProduct = require("@/api/importProduct");
var _vuePropertyDecorator = require("vue-property-decorator");
var _lodash = require("lodash");
var _product = require("@/api/product");
var ImportModal = /*#__PURE__*/function (_Vue) {
  function ImportModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ImportModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ImportModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "loadingSubmit", false);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      data: []
    });
    (0, _defineProperty2.default)(_this, "rules", {
      name: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "products", []);
    (0, _defineProperty2.default)(_this, "providers", []);
    (0, _defineProperty2.default)(_this, "query", {
      limit: 30,
      page: 1
    });
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "productId", "");
    (0, _defineProperty2.default)(_this, "totalMoney", 0);
    (0, _defineProperty2.default)(_this, "importStatus", "");
    (0, _defineProperty2.default)(_this, "ImportProductStatus", ImportProductStatus);
    (0, _defineProperty2.default)(_this, "ImportProductStatusTrans", ImportProductStatusTrans);
    return _this;
  }
  (0, _inherits2.default)(ImportModal, _Vue);
  return (0, _createClass2.default)(ImportModal, [{
    key: "transformTable",
    get: function get() {
      var _this2 = this;
      var data = [];
      this.totalMoney = 0;
      this.form.data.forEach(function (e) {
        e.name = e.product ? e.product.name : e.name;
        e.idNhanh = e.product ? e.product.idNhanh : e.idNhanh;
        e.quantityStock = e.inventory ? e.inventory.remain : e.quantityStock;
        e.total = e.amount * e.quantityImport;
        _this2.totalMoney += e.total;
        data.push(e);
      });
      return data;
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchProvider();
    }
  }, {
    key: "pasteEventQuantity",
    value: function pasteEventQuantity(e, row) {
      this.$set(row, "quantityImport", e);
    }
  }, {
    key: "pasteEventAmount",
    value: function pasteEventAmount(e, row) {
      this.$set(row, "amount", e);
    }
  }, {
    key: "handleSelect",
    value: function () {
      var _handleSelect = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(row) {
        var oldProduct, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              oldProduct = this.form.data.find(function (e) {
                return e.idNhanh == row;
              });
              if (!oldProduct) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", this.$notify.error({
                title: "Cảnh báo",
                message: "Sản phẩm đã tồn tại"
              }));
            case 3:
              _context.next = 5;
              return _nhanh.nhanhApi.updateProducts({
                id: row.toString()
              });
            case 5:
              res = _context.sent;
              this.form.data.push(res.data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleSelect(_x) {
        return _handleSelect.apply(this, arguments);
      }
      return handleSelect;
    }()
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(item, index) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!item.detailId) {
                _context2.next = 10;
                break;
              }
              _context2.next = 3;
              return this.$confirm("Xác nhận xoá sản phẩm", "Cảnh báo", {
                cancelButtonText: "Không",
                confirmButtonText: "Có",
                type: "warning"
              });
            case 3:
              this.form.data.splice(index, 1);
              _context2.next = 6;
              return _importProduct.importProductApi.deleteDetail(item.detailId);
            case 6:
              this.$notify({
                title: "Xoá sản phẩm",
                message: "Successfully",
                type: "success"
              });
              this.$emit("submit:success");
              _context2.next = 11;
              break;
            case 10:
              this.form.data.splice(index, 1);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleDelete(_x2, _x3) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var valid, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context3.sent;
              if (!valid) {
                _context3.next = 15;
                break;
              }
              _context3.prev = 4;
              this.loadingSubmit = true;
              data = {
                importProduct: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
                  dateDelivery: this.form.dateDelivery / 1000
                }),
                details: this.form.data.map(function (e) {
                  return {
                    productId: e.id,
                    quantityImport: e.quantityImport,
                    amount: e.amount,
                    quantityStock: e.idNhanh == 25778502 ? e.quantityRemain : e.quantityStock
                  };
                })
              };
              _context3.next = 9;
              return _importProduct.importProductApi.create(data);
            case 9:
              this.$notify.success({
                title: "Thêm mới",
                message: "Successfully"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 12:
              _context3.prev = 12;
              this.loadingSubmit = false;
              return _context3.finish(12);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4,, 12, 15]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context4.sent;
              if (!valid) {
                _context4.next = 16;
                break;
              }
              _context4.prev = 4;
              this.loadingSubmit = true;
              _context4.next = 8;
              return _importProduct.importProductApi.update(this.form.id, {
                importProduct: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
                  dateDelivery: this.form.dateDelivery / 1000
                })
              });
            case 8:
              _context4.next = 10;
              return this.updateDetail();
            case 10:
              this.$notify({
                title: "Thông báo",
                message: "Thành công!",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 13:
              _context4.prev = 13;
              this.loadingSubmit = false;
              return _context4.finish(13);
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4,, 13, 16]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "updateDetail",
    value: function () {
      var _updateDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var i, e, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.form.data.length)) {
                _context5.next = 14;
                break;
              }
              e = this.form.data[i];
              data = {
                productId: e.product ? e.product.id : e.id,
                quantityImport: e.quantityImport,
                amount: e.amount,
                quantityStock: e.idNhanh == 25778502 ? e.quantityRemain : e.quantityStock
              };
              if (e.detailId) {
                _context5.next = 9;
                break;
              }
              _context5.next = 7;
              return _importProduct.importProductApi.addDetail(this.form.id, {
                detail: data
              });
            case 7:
              _context5.next = 11;
              break;
            case 9:
              _context5.next = 11;
              return _importProduct.importProductApi.updateDetail(e.detailId, {
                detailImport: data
              });
            case 11:
              i++;
              _context5.next = 1;
              break;
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateDetail() {
        return _updateDetail.apply(this, arguments);
      }
      return updateDetail;
    }()
  }, {
    key: "fetchProducts",
    value: function () {
      var _fetchProducts = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var search,
          res,
          _args6 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              search = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : "";
              _context6.next = 3;
              return _product.productApi.findAllConfig((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), {}, {
                search: search
              }));
            case 3:
              res = _context6.sent;
              this.products = res.data.products;
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fetchProducts() {
        return _fetchProducts.apply(this, arguments);
      }
      return fetchProducts;
    }()
  }, {
    key: "fetchProvider",
    value: function () {
      var _fetchProvider = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _provider.providerApi.findAll({
                page: 1,
                limit: 50
              });
            case 2:
              res = _context7.sent;
              if ((0, _lodash.isEmpty)(res.data)) {
                this.providers = [];
              } else {
                this.providers = Object.values(res.data.providers);
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function fetchProvider() {
        return _fetchProvider.apply(this, arguments);
      }
      return fetchProvider;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate(type, selection) {
      this.visible = true;
      this.status = "create";
      this.form = {
        data: selection.map(function (e) {
          return (0, _objectSpread2.default)({}, e);
        }),
        categoryId: type
      };
      this.importStatus = ImportProductStatus.New;
      this.fetchProducts();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        data: data.detailImports.map(function (e) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
            detailId: e.id
          });
        }),
        dateDelivery: data.dateDelivery * 1000,
        providerId: data.provider && data.provider.id
      });
      this.visible = true;
      this.status = "update";
      this.importStatus = data.status;
      this.fetchProducts();
    }
  }]);
}(_vuePropertyDecorator.Vue);
ImportModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ImportModal);
var _default = exports.default = ImportModal;
var ImportProductStatus;
(function (ImportProductStatus) {
  ImportProductStatus["New"] = "NEW";
  ImportProductStatus["Complete"] = "COMPLETE";
})(ImportProductStatus || (exports.ImportProductStatus = ImportProductStatus = {}));
var ImportProductStatusTrans = exports.ImportProductStatusTrans = (0, _defineProperty2.default)((0, _defineProperty2.default)({}, ImportProductStatus.Complete, "Thành đơn"), ImportProductStatus.New, "Chưa thành đơn");